import { createActionBundle } from 'utilities/request';

export const {
  request: requestDocumentReference,
  success: requestDocumentReferenceSuccess,
  failure: requestDocumentReferenceFailure,
} = createActionBundle('DOCUMENT_REFERENCE');

export const {
  request: requestPostDocumentReference,
  success: requestPostDocumentReferenceSuccess,
  failure: requestPostDocumentReferenceFailure,
} = createActionBundle('POST_DOCUMENT_REFERENCE');

export const {
  request: requestDeleteDocumentReference,
  success: requestDeleteDocumentReferenceSuccess,
  failure: requestDeleteDocumentReferenceFailure,
} = createActionBundle('DELETE_DOCUMENT_REFERENCE');
